import { useTheme } from '@/theme/ThemeProvider';
import { THEMES, type ThemeName } from '@/theme/themes';

/**
 * Personal Cozy ↔ Graphite appearance switch — the two "house" looks every user
 * can flip between (warm paper vs. clean graphite). Persists per device through
 * the theme provider; the full 14-theme org picker still lives at
 * Admin → Appearance for the Super Admin.
 */
export function ThemeToggle({ compact = false }: { compact?: boolean }) {
  const { theme, setTheme } = useTheme();
  const isGraphite = theme === 'Graphite';
  const next: ThemeName = isGraphite ? 'Cozy' : 'Graphite';
  const label = isGraphite ? 'Graphite' : 'Cozy';
  if (compact) {
    return (
      <button
        onClick={() => setTheme(next)}
        title={`Appearance: ${label} — switch to ${next}`}
        aria-label={`Switch appearance to ${next}`}
        style={{ display: 'grid', placeItems: 'center', width: 38, height: 38, borderRadius: 99, border: '1px solid var(--line-2)', background: 'var(--card)', cursor: 'pointer', flex: 'none' }}
      >
        <span style={{ display: 'inline-flex', alignItems: 'center' }} aria-hidden>
          <span style={{ width: 13, height: 13, borderRadius: '50%', background: THEMES.Cozy.swatch[0], border: '1.5px solid var(--card)' }} />
          <span style={{ width: 13, height: 13, borderRadius: '50%', background: THEMES.Graphite.swatch[0], border: '1.5px solid var(--card)', marginLeft: -5 }} />
        </span>
      </button>
    );
  }
  return (
    <button
      onClick={() => setTheme(next)}
      title={`Appearance: ${label} — switch to ${next}`}
      aria-label={`Switch appearance to ${next}`}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        border: '1px solid var(--line-2)',
        background: 'var(--card)',
        borderRadius: 99,
        padding: '6px 11px',
        cursor: 'pointer',
        fontFamily: 'var(--mono)',
        fontSize: 12,
        fontWeight: 500,
        color: 'var(--ink-2)',
        letterSpacing: '.04em',
      }}
    >
      <span style={{ display: 'inline-flex', alignItems: 'center' }} aria-hidden>
        <span style={{ width: 13, height: 13, borderRadius: '50%', background: THEMES.Cozy.swatch[0], border: '1.5px solid var(--card)' }} />
        <span style={{ width: 13, height: 13, borderRadius: '50%', background: THEMES.Graphite.swatch[0], border: '1.5px solid var(--card)', marginLeft: -5 }} />
      </span>
      {label}
    </button>
  );
}
